import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'pg-form-row, [row], [pgFormRow], grit-form-row, [gritFormRow]',
  templateUrl: './pg-form-row.component.html',
  styleUrls: ['./pg-form-row.component.scss'],
})
export class PgFormRowComponent implements OnInit {
  @HostBinding('class.row')
  _classRow = true;
  constructor() {}

  ngOnInit() {}
}
